import { render, staticRenderFns } from "./product-reviews.vue?vue&type=template&id=cdb80348&"
import script from "./product-reviews.vue?vue&type=script&lang=js&"
export * from "./product-reviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports